import customAxios from '../../customAxios';

import {ADMIN_WITHDRAWAL_FROM_ACCOUNT} from '../../routes';

const adminWithdrawalFromAccount = async (amount: number | string) => {
  try {
    return (await customAxios.get(`${ADMIN_WITHDRAWAL_FROM_ACCOUNT}?amount=${amount}`)).data;
  } catch (error: any) {
    console.log({ ADMIN_WITHDRAWAL_FROM_ACCOUNT: error });
  }
};

export default adminWithdrawalFromAccount;
